import { gql } from '@apollo/client/core'

export const CREATE_CHECKOUT_SESSION = gql`
  mutation createStripeCheckoutSession($input: CreateStripeCheckoutSessionInput!) {
    createStripeCheckoutSession(input: $input) {
      checkoutSessionUrl
      errors {
        message
        path
      }
    }
  }
`
